<template>
    <section
        class="pricing section"
        :class="[
            topOuterDivider && 'has-top-divider',
            bottomOuterDivider && 'has-bottom-divider',
            hasBgColor && 'has-bg-color',
            invertColor && 'invert-color'
        ]">
        <div id="pricing" class="container">
            <div
                class="pricing-inner section-inner"
                :class="[
                    topDivider && 'has-top-divider',
                    bottomDivider && 'has-bottom-divider'
                ]">
                <c-section-header :data="sectionHeader" class="center-content invert-color" />
                <div
                    class="tiles-wrap illustration-section-07"
                    :class="[
                        pushLeft && 'push-left',
                    ]">
                    <div class="tiles-item reveal-scale-up">
                        <div class="tiles-item-inner has-shadow">
                            <div class="pricing-item-content">
                                <div class="pricing-item-header pb-16 mb-24">
                                    <div class="pricing-item-price mb-4">
                                        <span class="pricing-item-price-currency h2 text-color-low">{{ getPricingData(this.priceOutput.plan1, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan1, 1) }}</span>
                                    </div>
                                    <div class="text-color-low text-xs">
                                        Billed {{ getPricingData(this.priceOutput.plan1, 2) }}
                                    </div>
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div class="pricing-item-features-title fw-500 text-xs text-color-high mb-24">
                                        Most Popular
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">Premium Indicator Access on TradingView</li>
                                        <li class="is-checked">Mobile Alerts Included</li>
                                        <li class="is-checked">Enhanced Settings Controls</li>
                                        <li class="is-checked">Live Discord Support</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button tag="a" color="primary" wide href="javascript:void(0)" data-cb-type="checkout" data-cb-item-0="Smart-Algo-Premium-Indicator-Monthly" data-cb-item-0-quantity="1">Start 7 day free trial</c-button>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="200">
                        <div class="tiles-item-inner has-shadow">
                            <div class="pricing-item-content">
                                <div class="pricing-item-header pb-16 mb-24">
                                    <div class="pricing-item-price mb-4">
                                        <span class="pricing-item-price-currency h2 text-color-low">{{ getPricingData(this.priceOutput.plan2, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan2, 1) }}</span>
                                    </div>
                                    <div class="text-color-low text-xs">
                                        Billed {{ getPricingData(this.priceOutput.plan2, 2) }}
                                    </div>
                                    <c-image
                                        class="pricing-item-icon"
                                        :src="require('@/assets/images/pricing-icon.svg')"
                                        alt="Diamond"
                                        :width="38"
                                        :height="40" />
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div class="pricing-item-features-title fw-500 text-xs text-color-high mb-24">
                                        $̶1̶9̶4̶.̶9̶7̶ Save 30%
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">Premium Indicator Access on TradingView</li>
                                        <li class="is-checked">Mobile Alerts Included</li>
                                        <li class="is-checked">Enhanced Settings Controls</li>
                                        <li class="is-checked">Live Discord Support</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button tag="a" color="primary" wide href="javascript:void(0)" data-cb-type="checkout" data-cb-item-0="Smart-Algo-Premium-Indicator-Quarterly" data-cb-item-0-quantity="1">Start 7 day free trial</c-button>
                            </div>
                        </div>
                    </div>

                    <div class="tiles-item reveal-scale-up" data-reveal-delay="400">
                        <div class="tiles-item-inner has-shadow">
                            <div class="pricing-item-content">
                                <div class="pricing-item-header pb-16 mb-24">
                                    <div class="pricing-item-price mb-4">
                                        <span class="pricing-item-price-currency h2 text-color-low">{{ getPricingData(this.priceOutput.plan3, 0) }}</span>
                                        <span class="pricing-item-price-amount h1">{{ getPricingData(this.priceOutput.plan3, 1) }}</span>
                                    </div>
                                    <div class="text-color-low text-xs">
                                        Billed {{ getPricingData(this.priceOutput.plan3, 2) }}
                                    </div>
                                </div>
                                <div class="pricing-item-features mb-40">
                                    <div
                                        class="pricing-item-features-title fw-500 text-xs text-color-high mb-24">
                                        $̶7̶7̶9̶.̶8̶8̶ Save 40%
                                    </div>
                                    <ul class="pricing-item-features-list list-reset text-xs mb-32">
                                        <li class="is-checked">Premium Indicator Access on TradingView</li>
                                        <li class="is-checked">Mobile Alerts Included</li>
                                        <li class="is-checked">Enhanced Settings Controls</li>
                                        <li class="is-checked">Live Discord Support</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pricing-item-cta mb-8">
                                <c-button tag="a" color="primary" wide href="javascript:void(0)" data-cb-type="checkout" data-cb-item-0="Smart-Algo-Premium-Indicator-Yearly" data-cb-item-0-quantity="1">Start 7 day free trial</c-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { SectionTilesProps } from '@/utils/SectionProps.js'
import CSectionHeader from '@/components/sections/partials/SectionHeader.vue'
// import CSwitch from '@/components/elements/Switch.vue'
import CButton from '@/components/elements/Button.vue'
import CImage from '@/components/elements/Image.vue'

export default {
  name: 'CPricing',
  components: {
    CSectionHeader,
    // CSwitch,
    CButton,
    CImage
  },
  mixins: [SectionTilesProps],
  props: {
    pricingSwitcher: {
      type: Boolean,
      default: false
    },
    pricingSlider: {
      type: Boolean,
      default: false
    }        
  },
  data() {
    return {
      sectionHeader: {
        title: 'Simple and All Inclusive Membership',
        paragraph: ''
      },
      priceChangerValue: "0",
      priceInput: {
        // 0: "1,000",
        // 1: "1,250"
      },
      priceOutput: {
        plan1: {
          0: ["$", "64.99", "Monthly"],
        },
        plan2: {
          0: ["$", "136.95", "Quarterly"],
        },
        plan3: {
          0: ["$", "449.99", "Yearly"],
        }
      }
    }
  },
  methods: {    
    handlePricingSlide(e) {
      this.handleSliderValuePosition(e.target)
    },
    handleSliderValuePosition(input) {
      const multiplier = input.value / input.max
      const thumbOffset = this.thumbSize * multiplier
      const priceInputOffset = (this.thumbSize - this.$refs.sliderValue.clientWidth) / 2
      this.$refs.sliderValue.style.left = input.clientWidth * multiplier - thumbOffset + priceInputOffset + 'px'
    },
    getPricingData(values, set) {
      return set !== undefined ? values[this.priceChangerValue][set] : values[this.priceChangerValue]
    }
  },
  mounted() {
    if (this.pricingSlider) {
      this.$refs.slider.setAttribute('min', 0)
      this.$refs.slider.setAttribute('max', Object.keys(this.priceInput).length - 1)
      this.thumbSize = parseInt(window.getComputedStyle(this.$refs.sliderValue).getPropertyValue('--thumb-size'), 10)
      this.handleSliderValuePosition(this.$refs.slider)
    }        
  }
}
</script>